import MyProfileLayout from "@/modules/profile/layout";
import { useParams } from "react-router-dom";

const EmployeeProfileLayout = () => {
  const { employeeId } = useParams();

  return (
    <MyProfileLayout
      baseUrl={`/organization/employees/${employeeId}`}
      showIntegrations={false}
    />
  );
};

export default EmployeeProfileLayout;
